import { Colors } from "@template/style";

const styles = {
  header: { bgcolor: Colors.YELLOW },
} as const;

export default styles;
